import React, { useState, useMemo } from 'react';

function RichTextView({ value = '', maxLength }) {
  const [expanded, setExpanded] = useState(false);

  // Convert HTML string to plain text efficiently using useMemo
  const plainText = useMemo(() => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    return tempDiv.textContent || tempDiv.innerText || '';
  }, [value]);

  const shouldTruncate = plainText.length > maxLength;

  const tooltipText = shouldTruncate
    ? expanded
      ? 'Click to collapse'
      : 'Click to expand'
    : '';

  const toggleExpanded = () => {
    if (shouldTruncate) {
      setExpanded(prev => !prev);
    }
  };

  return (
    <div
      onClick={toggleExpanded}
      title={tooltipText}
      style={{
        cursor: shouldTruncate ? 'pointer' : 'default',
        userSelect: 'none',
      }}
    >
      {expanded || !shouldTruncate ? (
        <div dangerouslySetInnerHTML={{ __html: value }} />
      ) : (
        <div>{plainText.slice(0, maxLength)}...</div>
      )}
    </div>
  );
}

export default RichTextView;
